/**
 * MM / Cards — Moon Moon Agency
 * Le carrousel est un Splide monté par SplideManager (mm_components.js) :
 * drag, molette, flèches externes et slide active (.is-active) sont natifs.
 * Reste un seul cas à traiter : la slide active est élargie en desktop
 * (372px → 546px, transition CSS). Splide calcule sa destination au début
 * du mouvement en lisant les largeurs EN COURS — l'ancienne active encore
 * large, la nouvelle encore étroite — et se calerait donc trop loin une fois
 * la transition finie. On lui fait lire les largeurs finales (transitions
 * coupées), puis on rejoue l'élargissement.
 * Variant "grid" (2-3 blocks) : pas de Splide, rien à initialiser.
 */

/*********************************************************************************************
 * 🃏 MM CARDS MANAGER
 */
const MMCardsManager = {
	config: {
		selectors: {
			slider: '.mm-catslider__slider.splide',
		},
		classes: {
			active: 'is-active',
			measuring: 'is-measuring',
		},
	},

	/**
	 * SplideManager monte les sliders hors écran à l'approche (IntersectionObserver)
	 * et ré-émet à chaque (re)chargement de section dans l'éditeur
	 */
	init() {
		document.addEventListener('global:splide-initialized', () => {
			window.getElements(this.config.selectors.slider).forEach((root) => this._bind(root));
		});
	},

	_bind(root) {
		const splide = root._splide;
		if (!splide || root._mmCardsBound) return;
		root._mmCardsBound = true;

		const { active, measuring } = this.config.classes;
		const list = splide.Components.Elements.list;
		const { Slides } = splide.Components;

		// 'move' est émis APRÈS la bascule de .is-active (updateOnMove) et
		// AVANT le calcul de la destination (Transition.start, synchrone)
		splide.on('move', (index, prev) => {
			const next = Slides.getAt(index);
			const before = Slides.getAt(prev);
			if (!next || !before || index === prev) return;

			list.classList.add(measuring);
			void list.offsetWidth;

			// Destination calculée : retour à l'état précédent sans transition,
			// puis rebascule avec — l'élargissement joue pendant que la piste
			// glisse vers la bonne position
			Promise.resolve().then(() => {
				before.slide.classList.add(active);
				next.slide.classList.remove(active);
				void list.offsetWidth;
				list.classList.remove(measuring);
				void list.offsetWidth;
				before.slide.classList.remove(active);
				next.slide.classList.add(active);
			});
		});
	},
};

// Écoute posée avant DOMContentLoaded (script defer) : le 1er
// 'global:splide-initialized' de SplideManager n'est pas manqué
MMCardsManager.init();
